import React from 'react';
import Sidebar from '../Sidebar/Sidebar';
import Navbar from '../Navbar/Navbar';
import './stylesOld.scss';

export default function HeaderSideBarOld({
  window,
  menuOpen,
  drawerWidth,
  setMenuOpen,
  escopoAcesso,
  setDrawerWidth,
  onlySmallScreen
}) {
  const handleDrawerToggle = () => {
    setDrawerWidth(menuOpen ? 70 : 220);
    setMenuOpen(!menuOpen);
  };

  return (
    <>
      <Navbar
        handleDrawerToggle={handleDrawerToggle}
        menuOpen={menuOpen}
        onlySmallScreen={onlySmallScreen}
      />

      <Sidebar
        handleDrawerToggle={handleDrawerToggle}
        menuOpen={menuOpen}
        drawerWidth={drawerWidth}
        window={window}
        escopoAcesso={escopoAcesso}
      />
    </>
  );
}
